import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import colorSchemes, { PrimaryDark } from '../../../../../styling/theme';

const Remove = styled.button`
  padding-top: 4px;
  background: none;
  color: ${colorSchemes.veryDarkSaturatedBlue};
  cursor: pointer;
  font-size: 0.55rem;
  ${(props) => {
    const { authorsLength } = props;
    if (authorsLength > 1) {
      return css`
        &:hover {
          color: ${PrimaryDark};
        }
      `;
    }
    return null;
  }};

  &:focus {
    outline: none;
  }
`;

class RemoveField extends Component {
  componentDidMount = () => {};

  render() {
    const { clickHandle, authorsLength } = this.props;
    return (
      <Remove type="button" onClick={clickHandle} authorsLength={authorsLength}>
        <i className="fas fa-trash-alt fa-2x" />
      </Remove>
    );
  }
}
RemoveField.propTypes = {
  clickHandle: PropTypes.func.isRequired,
};
export default RemoveField;
